import { poisBountyAssets } from "assets/cdn";
import classNames from "classnames";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { getEventEndedClassNames } from "../ProgressSteps/lib/Step/helper";
import { useImagePath } from "hooks";
import { Container } from "./styles";

export const EventEndedState = () => {
	const { isPortrait, isPageVariant } = usePoisBountyContext();
	const { getImage } = useImagePath("cdn");

	return (
		<Container
			className={classNames(getEventEndedClassNames(isPortrait, isPageVariant))}
		>
			<img
				src={getImage(poisBountyAssets.v3.eventEnded.treasureChest)}
				alt="Treasure Chest"
			/>
			<p style={{ paintOrder: "stroke fill" }}>
				Your uncollected rewards during this event were sent to your in-game
				inbox
			</p>
		</Container>
	);
};
